import { format, formatDistanceToNowStrict, isValid } from 'date-fns';
import { ru } from 'date-fns/locale';

export function toDate(value?: string | Date | null): Date | undefined {
    if (!value) return undefined;
    const date = value instanceof Date ? value : new Date(value);
    return isValid(date) ? date : undefined;
}

export function formatDate(value?: string | Date | null, pattern = 'd MMM yyyy'): string {
    const date = toDate(value);
    return date ? format(date, pattern, { locale: ru }) : '—';
}

export function formatDateTime(value?: string | Date | null): string {
    return formatDate(value, 'd MMM yyyy, HH:mm');
}

export function formatRelative(value?: string | Date | null): string {
    const date = toDate(value);
    return date ? formatDistanceToNowStrict(date, { locale: ru, addSuffix: true }) : '—';
}

export function formatPeriod(from?: string | null, to?: string | null): string {
    const start = toDate(from);
    const end = toDate(to);
    if (!start && !end) return 'Без ограничений';
    if (start && end) return `${formatDate(start)} — ${formatDate(end)}`;
    if (start) return `с ${formatDate(start)}`;
    return `до ${formatDate(end)}`;
}

export const yesNo = (value?: boolean | null): string => (value ? 'Да' : 'Нет');

export function formatNumber(value?: number | null): string {
    if (value === undefined || value === null || Number.isNaN(value)) return '0';
    return new Intl.NumberFormat('ru-RU').format(value);
}

/** Safe file name for exports. */
export function sanitizeFileName(value: string, fallback = 'export'): string {
    const normalized = value
        .replace(/[\\/:*?"<>|]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 80);
    return normalized || fallback;
}

export function fileTimestamp(now = new Date()): string {
    return format(now, 'yyyyMMdd-HHmm');
}
